import { useQueryClient } from '@tanstack/react-query';
import { DateTime } from 'luxon';
import { FC, MouseEvent } from 'react';

import { ReactComponent as TrashIcon } from '@/assets/icons/trashbin.svg';
import ActionsDropdown, {
  ActionsDropdownButton,
} from '@/components/ActionsDropdown';
import { ActionsWrap, Td } from '@/components/Table';
import useAlerts from '@/hooks/useAlerts';
import { api } from '@/utils/api';

import { BlacklistedKeyword } from './BlacklistModal';

interface Props {
  row: BlacklistedKeyword;
}

const BlacklistTableRow: FC<Props> = ({ row }) => {
  const alerts = useAlerts();
  const queryClient = useQueryClient();

  const onDelete = async (e: MouseEvent<HTMLButtonElement>) => {
    try {
      e.stopPropagation();

      const confirm = await alerts.confirm(
        `Are you sure you want to delete this keyword?`,
        row.text,
      );

      if (!confirm) return;

      await api.delete<never, { id: number }>(
        `/v1/editorial/queue/blacklisted-keywords/${row.id}`,
      );

      await queryClient.invalidateQueries(['dq_blacklisted_keywords']);

      alerts.close();
    } catch (e) {
      alerts.error();
    }
  };

  return (
    <tr>
      <Td>{row.text}</Td>
      <Td>
        {DateTime.fromISO(row.created_at).toFormat('yyyy-LL-dd HH:mm:ss')}
      </Td>
      <Td $actionsCol>
        <ActionsWrap>
          <ActionsDropdown zIndex={50}>
            <ActionsDropdownButton as="button" onClick={onDelete}>
              <span>
                <TrashIcon />
              </span>
              Delete
            </ActionsDropdownButton>
          </ActionsDropdown>
        </ActionsWrap>
      </Td>
    </tr>
  );
};

export default BlacklistTableRow;
